import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { layout } from "../style";
import { teams } from "../constants";
import { linkedin } from "../assets";

const AboutUs = () => {
  const [selectedTeam, setSelectedTeam] = useState(null);

  const teamCategories = [
    { key: 'direccion', name: 'Dirección', image: teams.direccion.members[0].photo },
    { key: 'informatica', name: 'Equipo Informático', image: teams.informatica.members[0].photo },
    { key: 'electronica', name: 'Equipo Electrónico', image: teams.electronica.members[0].photo },
    { key: 'mecanica', name: 'Equipo Mecánico', image: teams.mecanica.members[0].photo },
  ];

  return (
    <section className={`${layout.section} relative`}>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto w-full"
      >
        {teamCategories.map((category, index) => (
          <TeamCard
            key={category.key}
            name={category.name}
            image={category.image}
            index={index}
            onClick={() => setSelectedTeam(category.key)}
          />
        ))}
      </motion.div>

      <AnimatePresence>
        {selectedTeam && (
          <TeamModal
            team={teams[selectedTeam]}
            onClose={() => setSelectedTeam(null)}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

const TeamCard = ({ name, image, onClick, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      whileHover={{ y: -10 }}
      className="bg-white rounded-2xl p-8 cursor-pointer hover:border-secondary border border-slate-100 shadow-sm hover:shadow-xl transition-all flex flex-col items-center group"
      onClick={onClick}
    >
      <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-slate-100 group-hover:border-secondary transition-colors mb-6 flex justify-center items-center bg-slate-50">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
      <h3 className="text-xl text-darkBlue font-bold text-center group-hover:text-secondary transition-colors">{name}</h3>
      <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity flex items-center text-secondary text-sm font-semibold">
        Ver equipo <span className="ml-2">→</span>
      </div>
    </motion.div>
  );
};

const TeamModal = ({ team, onClose }) => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-slate-900/40 backdrop-blur-md flex items-center justify-center z-[150] p-4"
    >
      <motion.div 
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 20 }}
        className="bg-white rounded-3xl p-8 max-w-5xl w-full max-h-[85vh] overflow-y-auto relative border border-slate-100 shadow-2xl"
      >
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-slate-400 text-3xl hover:text-darkBlue transition-colors"
        >
          ×
        </button>
        <h2 className="text-4xl text-darkBlue font-bold mb-10 text-center tracking-tight">
          {team.name}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.members.map((member, idx) => (
            <motion.div 
              key={member.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
              className="bg-slate-50 rounded-2xl p-6 text-center border border-slate-100 hover:border-secondary/30 transition-all group flex flex-col items-center justify-center"
            >
              <div className="relative mb-4">
                <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-slate-100 group-hover:border-secondary transition-colors flex justify-center items-center bg-white shadow-sm">
                  <img
                    src={member.photo}
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform"
                  />
                </div>
                
                {member.link && (
                  <a 
                    href={member.link} 
                    target="_blank" 
                    rel="noreferrer"
                    className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full bg-white border border-slate-200 flex items-center justify-center hover:bg-slate-50 hover:scale-110 transition-all shadow-md z-10 p-1.5"
                  >
                    <img src={linkedin} alt="LinkedIn" className="w-full h-full object-contain" />
                  </a>
                )}
              </div>
              
              <h3 className="text-darkBlue font-bold text-lg leading-tight">{member.name}</h3>
              <p className="text-secondary text-[13px] font-semibold mt-1 uppercase tracking-wider">{member.role}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
};

export default AboutUs;